import * as React from 'react';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { destroy, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { flow, forEach } from 'lodash';
import { connect } from 'react-redux';
import { IAuthActions, IAuthState } from '../../../../services/auth/models';
import { IPolicy, IPolicyApplication } from '../../../../data/api/models';
import { FormattedNumber } from 'react-intl';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as authActions } from '../../../../services/auth/reducer';
import { IStore } from '../../../../redux/IStore';
import RepurchaseComponent from './repurchase.component';
import { DATE_FORMAT } from '../../../../util/validators';
import moment = require('moment');
// import { FaSpinner } from 'react-icons/fa';
// import steps from '../../../Quote/steps';
// import confirm from 'react-confirm2';

interface IPolicyDetailProps {
  quote: IQuoteState;
  auth: IAuthState;
  branding: IBrandingState;
  card: any;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
    calculate: any;
    branding: IBrandingActions,
    quote: IQuoteActions;
    destroy(formName: string);
  };
}

interface IPolicyDetailStates {
  isRetrievingQuote: boolean;
  customerLapsed: boolean;
  showRepurchase: boolean;
}

class PolicyDetail extends React.Component<IPolicyDetailProps, IPolicyDetailStates> {

  constructor(props) {
    super(props);

    const { auth } = this.props;
    const selectedQuote = this.getSelectedQuote(auth.customer.renewals);

    this.state = {
      isRetrievingQuote: false,
      customerLapsed: selectedQuote && selectedQuote.status === 'customer lapsed',
      showRepurchase: false,
    };
  }

  public toggleCustomerLapsed = () => {
    this.setState({ customerLapsed: !this.state.customerLapsed });
  };

  private getSelectedQuote(applications: IPolicyApplication[]) {
    let selectedQuote = null;

    forEach(applications, (quoteSelected, level) => {
      if (location.pathname.match(quoteSelected.id)) {
        selectedQuote = quoteSelected;
      }
    });

    return selectedQuote;
  }

  // -- Edit Quote support method
  // private handleGetNewQuote = () => {
  //   const { actions } = this.props;
  //   actions.destroy('quote');
  //   actions.quote.reset();
  //   actions.quote.loadDestinations();
  //   actions.push('/');
  // };

  // -- Edit Quote support method
  // private handleEditAutoRenewal = () => {
  //   confirm('Important Information', {
  //     confirmLabel: 'Proceed',
  //     description: (
  //       <span>
  //         Your policy will automatically renew based on the details we hold.
  //         To update your quote please ensure you save any changes.
  //       </span>
  //     ),
  //     done: () => {
  //       this.handleEditQuote();
  //       return;
  //     },
  //     close: () => {
  //       return;
  //     },
  //   });
  // };

  // -- Edit Quote support method
  // private showInfoMessageHandler = () => {
  //   confirm('Important Information', {
  //     confirmLabel: 'Ok',
  //     description: (
  //       <span>
  //         Please check the details of the cover you are selecting carefully.
  //         We have recently changed some of the products limits and features.
  //         If you would like more information please call us on 0333 2349913.
  //       </span>
  //     ),
  //     done: () => {
  //       this.handleEditQuote();
  //       return;
  //     },
  //     close: () => {
  //       return;
  //     },
  //   });
  // };

  // -- Edit Quote support method
  // private handleEditQuote = () => {
  //   const { actions, auth } = this.props;
  //   this.setState({
  //     isRetrievingQuote: true,
  //   });
  //   let selectedQuote = this.getSelectedQuote(auth.customer.renewals);
  //
  //   if (!selectedQuote) {
  //     selectedQuote = this.getSelectedQuote(auth.customer.policyApplications);
  //   }
  //
  //   actions.quote.retrieveQuote(selectedQuote);
  //
  //   this.initForm(selectedQuote);
  // };

  // -- Edit Quote support method
  // private initForm = (selectedQuote) => {
  //   const { actions, quote, branding } = this.props;
  //
  //   // Re-init form
  //   actions.destroy('quote');
  //   actions.quote.reset();
  //   const product = actions.branding.getProduct();
  //   const lastStep = last(selectedQuote.steps);
  //   const quoteSteps = steps(branding.channel);
  //   let route = null;
  //
  //   quoteSteps.forEach((step) => {
  //     if (step.key !== lastStep) {
  //       return;
  //     }
  //
  //     route = step.route;
  //   });
  //
  //   actions.quote.initFromProduct(product, quote, branding);
  //   actions.quote.loadDestinations();
  //
  //   if (selectedQuote.schemeId && lastStep === 'schemeChoice') {
  //     set(selectedQuote, 'schemeId', '');
  //   }
  //
  //   // Set some data
  //   actions.quote.retrieveQuote(selectedQuote);
  //
  //   // Recalculate so that we can get fill up the quotes available for the policy
  //   actions.quote.calculate(selectedQuote, false).then(() => {
  //     // define an initial step if user is retrieving quote from b2b
  //     if (!selectedQuote.steps) {
  //       actions.quote.setSteps([quoteSteps[0].key]);
  //     }
  //
  //     const step = selectedQuote.steps && selectedQuote.steps.length ? quoteSteps.filter((step) => {
  //       return step.key === selectedQuote.steps[0];
  //     }) : [];
  //
  //     if (step.length) {
  //       actions.push(step[0].route);
  //     } else {
  //       actions.push('/');
  //     }
  //   });
  // };

  private isAnnual = (type) => {
    return type === 'annual' || type === 'longstay';
  };

  private getCoverDates = (isDisplayingPolicy, policy, selectedQuote) => {
    const policyDates = (policy) => this.isAnnual(policy.metadata.scheme_type) ? (`${policy.commencesAt}`) : (`${policy.commencesAt} - ${policy.expiresAt}`);
    const quoteDates = (selectedQuote) => this.isAnnual(selectedQuote.tripType) ? (`${selectedQuote.startDate}`) : (`${selectedQuote.startDate} - ${selectedQuote.endDate}`);
    return isDisplayingPolicy ? policyDates(policy) : quoteDates(selectedQuote);
  };

  private getDestinations = (isDisplayingPolicy, policy, selectedQuote): { label: string, value: string[] } => {
    const regionName = (region) => {
      const { actions } = this.props;
      // This will always be the Leisure Travel Product even for renewals
      const product = actions.branding.getProduct();
      if (product === null) {
        return region;
      }
      if (product.metadata.regions === undefined || product.metadata.regions[region] === undefined) {
        return region;
      }
      return product.metadata.regions[region];
    };

    const type = isDisplayingPolicy ? policy.metadata.scheme_type : selectedQuote.tripType;
    const region = regionName(isDisplayingPolicy ? policy.metadata.region : selectedQuote.region);
    const destinations = isDisplayingPolicy ? policy.metadata.destinations : selectedQuote.destinations;

    return this.isAnnual(type) ? {
      label: 'Region', value: [region],
    } : {
      label: 'Destination(s)', value: destinations,
    };
  };

  private renderDetails = (isDisplayingPolicy, policy, selectedQuote) => {
    // let status = isDisplayingPolicy ? policy.status : selectedQuote.status;
    // if (!isDisplayingPolicy && selectedQuote.quoteType === 'renewal') {
    //   status += '/' + selectedQuote.renewalStatus;
    // }
    const destinations = this.getDestinations(isDisplayingPolicy, policy, selectedQuote);
    const options = isDisplayingPolicy ? policy.metadata.options : selectedQuote.options;
    const groupType = isDisplayingPolicy ? policy.metadata.traveller_group : selectedQuote.groupType;
    const travellers = isDisplayingPolicy ? policy.metadata.adults : selectedQuote.travellers;
    const travellersStr = isDisplayingPolicy ?
      travellers?.map(traveller => `${traveller.title} ${traveller.first_name} ${traveller.last_name} (${moment(traveller.dob).format(DATE_FORMAT)})`) :
      travellers?.map(traveller => `${traveller.title} ${traveller.firstName} ${traveller.lastName} (${traveller.dob})`);

    return (<>
      <div className={'policy-details-grid'}>

        <div className={'label-col'}>Cover Type</div>
        <div className={'value-col'}>{isDisplayingPolicy ? policy.metadata.scheme_type : selectedQuote.tripType}</div>

        <div className={'label-col'}>Cover Dates</div>
        <div className={'value-col'}>{this.getCoverDates(isDisplayingPolicy, policy, selectedQuote)}</div>

        <div className={'label-col'}>{destinations.label}</div>
        <div className={'value-col'}>{destinations.value.map((v, k) => (<div key={k}>{v}</div>))}</div>

        <div className={'label-col'}>Options</div>
        <div className={'value-col'}>{
          Object.keys(options)
            .filter(k => options[k] === true)
            .map((k) => (<div key={k}>{k.replace('_', ' ')}</div>))
        }</div>

        <div className={'label-col'}>Traveller Group</div>
        <div className={'value-col'}>{groupType}</div>

        <div className={'label-col'}>Travellers</div>
        <div className={'value-col'}>{travellersStr?.map((v, i) => (<div key={i}>{v}</div>))}</div>

        {isDisplayingPolicy && (<>
          <div className={'label-col'}>Premium</div>
          <div className={'value-col'}>
            <FormattedNumber
              value={policy.totalPremiumValue}
              style="currency"
              currency="GBP"
            />
          </div>
        </>)}

        {isDisplayingPolicy && (<>
          <div className={'label-col'}>Auto Renewing</div>
          <div className={'value-col'}>{policy.renewalStatus === 'auto' ? 'Yes' : 'No'}</div>
        </>)}

      </div>
    </>);
  };

  private renderDocuments = (isDisplayingPolicy, policy, selectedQuote) => {
    const renderDocs = (documents, hideLetters = true) => {
      return (
        <Row className="customer-documents">
          {documents
            ?.filter(document => !hideLetters || !document?.displayName?.toLowerCase().includes('letter'))
            ?.map((document, key) => {
              return (
                <Col sm={6} key={key}>
                  <a href={document.filePath} target="_blank">
                    <div className="document-btn">
                      {document.displayName}
                    </div>
                  </a>
                </Col>
              );
            })}
        </Row>
      );
    };

    return (isDisplayingPolicy ? renderDocs(policy.documents) : renderDocs(selectedQuote.documents, false));
  };

  private unlapseRenewal = () => {
    const { actions, auth } = this.props;

    const selectedQuote = this.getSelectedQuote(auth.customer.renewals);

    if (!selectedQuote) {
      return;
    }

    actions.quote.unlapseRenewal(selectedQuote.id).then((data) => {
      this.setState({ customerLapsed: false });
      const promises = [];
      promises.push(actions.auth.reloadCustomer());
      return Promise.all(promises);
    });
  };

  private toggleRepurchase = () => {
    this.setState({ showRepurchase: !this.state.showRepurchase });
  };

  public renderRepurchaseAlert = (branding: IBrandingState) => {
    return (
      <Alert bsStyle={'warning'} style={{ color: '#337ab7', marginTop: 20 }}>
        If you wish to purchase this quote please click "Pay for renewal" button below.
        <br /><br />
        If you wish to amend your quote or update your Statement of Fact please contact us via Telephone: {branding.channel.phone}.
        Email: {branding.channel.email}
      </Alert>
    );
  };

  public render() {
    const { auth, location, branding, actions: { quote, push }, card } = this.props;
    const { isRetrievingQuote } = this.state;

    let policy: IPolicy = null;
    let isDisplayingPolicy = false;

    forEach(auth.customer.policies, (policySelected) => {
      if (location.pathname.match(policySelected.id)) {
        policy = policySelected;
        isDisplayingPolicy = true;
      }
    });

    let selectedQuote = this.getSelectedQuote(auth.customer.renewals);

    if (!selectedQuote) {
      selectedQuote = this.getSelectedQuote(auth.customer.policyApplications);
    }

    if (!policy && !selectedQuote) {
      return null;
    }

    // -- EDIT BUTTON
    // let editButton = 'VIEW / EDIT QUOTE';
    // let editButtonClickHandler = isDisplayingPolicy ? this.handleGetNewQuote : this.handleEditQuote;
    //
    // if (isDisplayingPolicy) {
    //   editButton = 'NEW QUOTE';
    // } else if (selectedQuote.quoteType === 'renewal') {
    //   editButton = 'RENEW POLICY';
    //
    //   if (selectedQuote.renewalStatus === 'auto') {
    //     editButton = 'EDIT RENEWAL';
    //     editButtonClickHandler = this.handleEditAutoRenewal;
    //   }
    // } else {
    //   const createdAt = moment(selectedQuote.createdAt, moment.ISO_8601);
    //   const showInfoMessage = createdAt.isBetween(
    //     '2019-05-03T00:00:00+00:00',
    //     '2019-06-03T06:59:59+00:00', // Local time: 08:00:00
    //     'minute',
    //     '[]',
    //   );
    //
    //   if (showInfoMessage) {
    //     editButtonClickHandler = this.showInfoMessageHandler;
    //   }
    // }

    return (
      <Row className="page-container">
        <div className="customer-section-title">
          <h1>{isDisplayingPolicy ? `Policy ${policy.policyNumber}` : `Quote ${selectedQuote.quoteReference}`}</h1>
        </div>

        {(!isDisplayingPolicy && selectedQuote.quoteType === 'renewal') && this.renderRepurchaseAlert(branding)}

        <div className="blue-section-group">
          <div className="blue-section">
            {this.renderDetails(isDisplayingPolicy, policy, selectedQuote)}
          </div>
          <div className="blue-section">
            {this.renderDocuments(isDisplayingPolicy, policy, selectedQuote)}
          </div>
        </div>
        <div className="btn-bar">

          {/* -- EDIT BUTTON */}
          {/*{(!isDisplayingPolicy && !this.state.customerLapsed) && (*/}
          {/*  <Button*/}
          {/*    bsStyle="primary"*/}
          {/*    bsSize="lg"*/}
          {/*    className="pull-right"*/}
          {/*    onClick={editButtonClickHandler}*/}
          {/*    disabled={isRetrievingQuote}*/}
          {/*  >*/}
          {/*    {isRetrievingQuote && (<FaSpinner className="fa-spin" />)}{' '}*/}
          {/*    {editButton}*/}
          {/*  </Button>*/}
          {/*)}*/}

          {(!isDisplayingPolicy && this.state.customerLapsed) &&
            <Button
              bsStyle="primary"
              bsSize="lg"
              className="pull-right"
              onClick={this.unlapseRenewal}
              disabled={isRetrievingQuote}
            >
              UNCANCEL RENEWAL
            </Button>
          }

          {(selectedQuote?.quoteType === 'renewal' && branding?.channel?.products?.[0]?.metadata?.document_group === 'SALT') && (
            <Button
              bsStyle="primary"
              bsSize="lg"
              className="pull-right" style={{ marginRight: '10px' }}
              onClick={this.toggleRepurchase}
              disabled={this.state.showRepurchase}
            >
              Pay for renewal
            </Button>
          )}

          <Link to="/account/summary" className="return-to-account-btn">
            Return to account summary
          </Link>
        </div>

        {this.state.showRepurchase && (
          <RepurchaseComponent branding={branding} quote={selectedQuote} quoteActions={quote} push={push} cardDetails={card} />
        )}

      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const card = selector(state, 'card');

      return {
        tripType,
        region,
        maxTripDuration,
        groupType,
        startDate,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        card,
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        // selectedQuote: bindActionCreators({ ...quoteActions }, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(PolicyDetail);
